import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cb900e0f-c443-41f6-9df3-17a2db93c215/artifacts/qd501ira_D70BB6EE-7344-46BE-86BC-6C6D197A54F6.png";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="Resume Surgeon" className="h-10 w-10 rounded-xl" />
              <span className="font-bold text-xl" style={{ fontFamily: 'Outfit' }}>Resume Surgeon</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Professional ATS-friendly resume support with personal review on every project.
            </p>
            <p className="text-slate-500 text-xs mt-2 leading-relaxed">
              Every project starts with intake. Scope is confirmed before billing.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-slate-400">Services</h4>
            <ul className="space-y-2">
              <li><Link to="/services/resume-rewrite" className="text-slate-300 hover:text-white text-sm transition-colors">Resume Rewrite</Link></li>
              <li><Link to="/services/resume-refresh" className="text-slate-300 hover:text-white text-sm transition-colors">Resume Refresh</Link></li>
              <li><Link to="/services/linkedin-optimization" className="text-slate-300 hover:text-white text-sm transition-colors">LinkedIn Optimization</Link></li>
              <li><Link to="/services/cover-letter" className="text-slate-300 hover:text-white text-sm transition-colors">Cover Letter</Link></li>
              <li><Link to="/services/resume-review" className="text-slate-300 hover:text-white text-sm transition-colors">Resume Review</Link></li>
            </ul>
          </div>

          {/* Who We Help */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-slate-400">Who We Help</h4>
            <ul className="space-y-2">
              <li><Link to="/for/customer-service" className="text-slate-300 hover:text-white text-sm transition-colors">Customer Service</Link></li>
              <li><Link to="/for/office-admin" className="text-slate-300 hover:text-white text-sm transition-colors">Office & Admin</Link></li>
              <li><Link to="/for/career-change" className="text-slate-300 hover:text-white text-sm transition-colors">Career Changers</Link></li>
              <li><Link to="/for/entry-level" className="text-slate-300 hover:text-white text-sm transition-colors">Entry-Level</Link></li>
              <li><Link to="/for/operations" className="text-slate-300 hover:text-white text-sm transition-colors">Operations & Technicians</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-slate-400">Resources</h4>
            <ul className="space-y-2">
              <li><Link to="/pricing" className="text-slate-300 hover:text-white text-sm transition-colors">Pricing</Link></li>
              <li><Link to="/samples" className="text-slate-300 hover:text-white text-sm transition-colors">Before & After</Link></li>
              <li><Link to="/faq" className="text-slate-300 hover:text-white text-sm transition-colors">FAQ</Link></li>
              <li><Link to="/audit" className="text-slate-300 hover:text-white text-sm transition-colors">Free Quick Audit</Link></li>
              <li><Link to="/start" className="text-slate-300 hover:text-white text-sm transition-colors">Start Intake</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-slate-400">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/policies/terms" className="text-slate-300 hover:text-white text-sm transition-colors">Terms of Service</Link></li>
              <li><Link to="/policies/privacy" className="text-slate-300 hover:text-white text-sm transition-colors">Privacy Policy</Link></li>
              <li><Link to="/policies/refunds" className="text-slate-300 hover:text-white text-sm transition-colors">Refund Policy</Link></li>
              <li><a href="mailto:hello@resumesurgeon.net" className="text-slate-300 hover:text-white text-sm transition-colors">Contact Us</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Resume Surgeon. All rights reserved.
          </p>
          <p className="text-slate-500 text-sm">
            Personally reviewed. ATS-friendly. No job guarantees.
          </p>
        </div>
      </div>
    </footer>
  );
}
